import {
  Box,
  Paper as MuiPaper,
  Stack as MuiStack,
  Typography,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const MetricCard = styled(MuiPaper)(({ theme }) => ({
  flex: 1,
  minWidth: "150px",
  padding: theme.spacing(1),
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  backgroundColor: theme.palette.secondary.main,
  ...(theme.palette.mode === "dark" && {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
  }),
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1),
  right: theme.spacing(1),
  display: "flex",
  alignItems: "center",
}));

export const CardContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  minWidth: 0,
}));

export const Title = styled(Typography)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const ValueContainer = styled(MuiStack)(() => ({
  minWidth: 0,
  overflow: "hidden",
}));

export const Value = styled(Typography)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
}));
